import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { icons, brandingVariables } from 'smartsuite-ui';

const statusIcons = {
    bad: {
        iconClass: icons.xFilled,
        iconStyles: { color: brandingVariables.error }
    },
    good: {
        iconClass: icons.checkFilled,
        iconStyles: { color: brandingVariables.success }
    },
    ok: {
        iconClass: icons.warningFilled,
        iconStyles: { color: brandingVariables.warning }
    },
    unknown: {
        iconClass: icons.dashFilled,
        iconStyles: { color: brandingVariables.accent4 }
    }
};

function AirportStatusMap({ buttons, statusMapImage }) {
    const statusButtons = buttons.map(button => {
        const { iconClass, iconStyles } =
            statusIcons[button.statusValue] || statusIcons.unknown;

        if (!button.uri) {
            return (
                <span
                    key={JSON.stringify(button.styles)}
                    className="airport-status-map__link"
                    style={button.styles}
                >
                    <span
                        className={`airport-status-map__link-icon ${iconClass}`}
                        style={iconStyles}
                    />
                </span>
            );
        }

        return (
            <a
                key={JSON.stringify(button.styles)}
                className="airport-status-map__link"
                href={button.uri}
                style={button.styles}
                target={button.target}
            >
                <span
                    className={`airport-status-map__link-icon ${iconClass}`}
                    style={iconStyles}
                />
            </a>
        );
    });

    return (
        <div className="airport-status-map">
            <img
                className="airport-status-map__image"
                src={statusMapImage}
                alt="airportMap"
            />
            {statusButtons}
        </div>
    );
}

AirportStatusMap.propTypes = {
    buttons: PropTypes.instanceOf(Array).isRequired,
    statusMapImage: PropTypes.string
};

AirportStatusMap.defaultProps = {
    statusMapImage: ''
};

export default React.memo(AirportStatusMap, (prevProps, nextProps) =>
    _.isEqual(prevProps.buttons, nextProps.buttons)
);
